import React from "react";

import { ICellRendererParams } from "ag-grid-community";

import { useXeroDeepLink } from "hooks";
import XeroLogo from "img/Xero";

export function XeroContactLinkRenderer({ data }: ICellRendererParams) {
  const href = useXeroDeepLink({
    credentialsId: data?.credentialsId,
    contactId: data?.integrationId,
  });

  if (!href) {
    return null;
  }

  return (
    <a href={href} target="_blank" rel="noopener noreferrer">
      <XeroLogo width="20px" />
    </a>
  );
}
